/**
 * @file コンポーネント：執刀医情報 スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledSurgeonAnchor = styled.a`
    &[data-on-color="sub"] {
        color: #ffffff;
        font-size: 16px;
        line-height: 16px;
    }

    &[data-on-color="white"] {
        color: #000000;
        font-size: 13px;
        line-height: 14.6px;
    }
`;

export const StyledSurgeonText = styled.span`
    &[data-on-color="sub"] {
        color: #ffffff;
        font-size: 16px;
        line-height: 16px;
    }

    &[data-on-color="white"] {
        color: #000000;
        font-size: 13px;
        line-height: 14.6px;
    }
`;
